namespace TabAurous.Retail {
    export interface POSOrderBOMRow {
        TransBomId?: number;
        TransItemId?: number;
        RefTransBomId?: number;
        ProductId?: number;
        BOMProductId?: number;
        BOMAttributeId?: number;
        CertificateNo?: string;
        Lab?: string;
        Pieces?: number;
        Weight?: number;
        CalcOnId?: number;
        SettingId?: number;
        StoneStatusId?: Common.StoneStatus;
        SettingName?: string;
        BomRate?: number;
        BomAmount?: number;
        CCBomAmount?: number;
        Remarks?: string;
        Purity?: number;
        PureWeight?: number;
        DiscountPercent?: number;
        Discount?: number;
        Markup?: number;
        PointerWeight?: number;
        Parts?: number;
        TextureId?: number;
        ProductCode?: string;
        ProductName?: string;
        IsCustomerItem?: boolean;
        ItemType?: string;
        CostMethodId?: number;
        CalcOn?: string;
        HasBom?: boolean;
        ItemTypeId?: number;
        ProductTypeId?: number;
        SubCategoryId?: number;
        CategoryId?: number;
        ProductTypeCode?: string;
        ProductTypeName?: string;
        CategoryName?: string;
        SubCategoryName?: string;
        Attribute?: string;
        CalcUnitId?: number;
        SieveId?: number;
        GroupSieveId?: number;
        KaratId?: number;
        MetalColorId?: number;
        QualityId?: number;
        ShapeId?: number;
        StoneColorId?: number;
        StoneSizeId?: number;
        StoneCutId?: number;
        StonePolishId?: number;
        StoneSymmetryId?: number;
        StoneFluorescenceId?: number;
        StoneCuletId?: number;
        StoneGirdleId?: number;
        StoneTable?: string;
        StoneDepth?: string;
        GrossWeight?: number;
        SalesCostMethodId?: Common.CostMethod;
        PurchaseCostMethodId?: Common.CostMethod;
    }

    export namespace POSOrderBOMRow {
        export const idProperty = 'TransBomId';
        export const nameProperty = 'CertificateNo';
        export const localTextPrefix = 'Retail.POSOrderBOM';
        export const deletePermission = 'Retail:POSOrders:Delete';
        export const insertPermission = 'Retail:POSOrders:Add';
        export const readPermission = '*';
        export const updatePermission = 'Retail:POSOrders:Edit';

        export declare const enum Fields {
            TransBomId = "TransBomId",
            TransItemId = "TransItemId",
            RefTransBomId = "RefTransBomId",
            ProductId = "ProductId",
            BOMProductId = "BOMProductId",
            BOMAttributeId = "BOMAttributeId",
            CertificateNo = "CertificateNo",
            Lab = "Lab",
            Pieces = "Pieces",
            Weight = "Weight",
            CalcOnId = "CalcOnId",
            SettingId = "SettingId",
            StoneStatusId = "StoneStatusId",
            SettingName = "SettingName",
            BomRate = "BomRate",
            BomAmount = "BomAmount",
            CCBomAmount = "CCBomAmount",
            Remarks = "Remarks",
            Purity = "Purity",
            PureWeight = "PureWeight",
            DiscountPercent = "DiscountPercent",
            Discount = "Discount",
            Markup = "Markup",
            PointerWeight = "PointerWeight",
            Parts = "Parts",
            TextureId = "TextureId",
            ProductCode = "ProductCode",
            ProductName = "ProductName",
            IsCustomerItem = "IsCustomerItem",
            ItemType = "ItemType",
            CostMethodId = "CostMethodId",
            CalcOn = "CalcOn",
            HasBom = "HasBom",
            ItemTypeId = "ItemTypeId",
            ProductTypeId = "ProductTypeId",
            SubCategoryId = "SubCategoryId",
            CategoryId = "CategoryId",
            ProductTypeCode = "ProductTypeCode",
            ProductTypeName = "ProductTypeName",
            CategoryName = "CategoryName",
            SubCategoryName = "SubCategoryName",
            Attribute = "Attribute",
            CalcUnitId = "CalcUnitId",
            SieveId = "SieveId",
            GroupSieveId = "GroupSieveId",
            KaratId = "KaratId",
            MetalColorId = "MetalColorId",
            QualityId = "QualityId",
            ShapeId = "ShapeId",
            StoneColorId = "StoneColorId",
            StoneSizeId = "StoneSizeId",
            StoneCutId = "StoneCutId",
            StonePolishId = "StonePolishId",
            StoneSymmetryId = "StoneSymmetryId",
            StoneFluorescenceId = "StoneFluorescenceId",
            StoneCuletId = "StoneCuletId",
            StoneGirdleId = "StoneGirdleId",
            StoneTable = "StoneTable",
            StoneDepth = "StoneDepth",
            GrossWeight = "GrossWeight",
            SalesCostMethodId = "SalesCostMethodId",
            PurchaseCostMethodId = "PurchaseCostMethodId"
        }
    }
}
